import React from 'react';
import { createDashboardTableClassName } from './dashboardTableStyles';

type TProps = {
  text: string;
  primary?: boolean;
  asError?: boolean;
};

export const DashboardTableLabel: React.FC<TProps> = ({
  text,
  primary,
  asError,
}) => {
  const labelClassName = createDashboardTableClassName('label', {
    primary: primary === true,
    secondary: primary === false,
    error: asError,
  });

  return <div className={labelClassName}>{text}</div>;
};
